/* eslint-disable prefer-template */
import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import Button from "../../components/Button";
import Table from "../../components/Table/Table";
import { Grid } from "@mui/material";
import { TableSearch } from "../../components/Table/TableActions";
import { useState, useEffect } from "react";
import Modal from "../../components/Modal";
// import SelectGroup from "../../components/FormComponent/SelectGroup";
import { Icon } from "@iconify/react";
import Badge from "../../components/Badge";
import { useTruncate } from "../../hooks/useTruncate";
// import InputGroup from "../../components/FormComponent/InputGroup";
import { httprequest } from "../../data/api";
import { toast } from "react-toastify";
// import Select from "react-select";
import ReactPlayer from "react-player";
import useWindowSize from "../../hooks/useWindow";
import useStyles from "./styles";
import { useUserState } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
// import { Calendar } from "@fullcalendar/core";

// API Endpoints
const LEAVE_OPTIONS_ENDPOINT = "/api/v1/student-leave";
const TEACHER_ENDPOINT = "/api/v1/student-leave/teacher";

const LeaveMgt = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { userRole } = useUserState();
  const [leaveOptionModal, setLeaveOptionModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [searchResult, setSearchResult] = useState([]);
  const [allLeave, setAllLeave] = useState([]);
  const [helpModal, setHelpModal] = useState(false);

  const width = useWindowSize();
  const mobile = width < 600;

  // THis closes the help modal/video modal
  const handleCloseVideoModal = () => {
    setHelpModal(false);
  };

  const handleNavigate = (row) => {
    navigate(`/manage/student-leave-details/${row.id}`, { state: { row } });
  };

  /**
 * Handles input changes for leave options form
   * @param {object} e - event object
   */
  //   const handleChange = (e) => {
  //     const { name, value } = e.target;
  //     setLeaveOptions({ ...leaveOptions, [name]: value });
  //   };

  /**
 * Handles changes for multiple access select input
   * @param {object} e - event object
   */
  //   const handleMultipleAccessChange = (event) => {
  //     const selectedValue = event.map((item) => item.value);
  //     setLeaveOptions({ ...leaveOptions, access: selectedValue });
  //   };

  /**
 * Fetches all roles from API and filters out non-applicable roles
 */
  //   const getAllRoles = () => {
  //     httprequest.get(ROLES_ENDPOINT).then((res) => {
  //       const access = res?.data?.data?.filter((res) => res?.role_type !== "school_admin" && res?.role_type !== "guardian" && res.role_type !== "student");
  //       setMultipleAccess(access?.map((role) => {
  //         return {
  //           label: role?.role_name,
  //           value: role?.role_id
  //         };
  //       }));
  //     }).catch((err) => {
  //       toast.error(err?.response?.data);
  //     });
  //   };

  /**
 * Fetches all leave options and updates count
 */
  //   const getAlLeaveOptions = () => {
  //     httprequest.get(LEAVE_OPTIONS_ENDPOINT).then((res) => {
  //       setOptionsCount(res?.data?.data?.length);
  //     }).catch((err) => {
  //       toast.error(err?.response?.data?.message);
  //     });
  //   };

  /**
 * Closes the approve leave modal and resets current row
 * @function
 */
  const handleCloseApproveModal = () => {
    setApproveModal(false);
    setCurrentRow({});
  };

  /**
 * Closes the approve leave modal and resets current row
 * @function
 */
  const getAlLeave = () => {
    httprequest.get(userRole?.role_type === "employee" ? TEACHER_ENDPOINT : LEAVE_OPTIONS_ENDPOINT).then((res) => {
      setAllLeave(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  useEffect(() => {
    getAlLeave();
    // getAllRoles();
  }, []);

  // This is to trigger the modal
  // const handleApproveModal = (row) => {
  //   setApproveModal(true);
  //   setCurrentRow(row);
  // };

  // This triggers the leave option modal
  const handleLeaveOptionModal = () => {
    setLeaveOptionModal(!leaveOptionModal);
  };

  /**
 * Creates a new leave option after validation
 */
  //   const handleCreateLeaveOption = () => {
  //     if (optionsValidator.allValid()) {
  //       setIsLoading(true);
  //       httprequest.post(LEAVE_OPTIONS_ENDPOINT, leaveOptions).then((res) => {
  //         setIsLoading(false);
  //         toast.success(res?.data?.message);

  //         // --| Reset Leave Options to original state
  //         setLeaveOptions({ ...leaveOptions, type: "", duration: "", access: "", status: "active" });
  //         // getAlLeaveOptions();
  //         handleLeaveOptionModal();
  //       }).catch((err) => {
  //         setIsLoading(false);
  //         toast.error(err?.response?.data?.message);
  //       });
  //     } else {
  //       showOptionsValidator(true);
  //     }
  //   };

  /**
 * Filters leave requests based on search input
 * @function
 * @param {Object} e - The event object
 * @param {Object} e.target - The search input element
 * @param {string} e.target.value - The search query
 */
  const handleSearchLeaveOptions = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = allLeave?.filter((data) => valArray?.every(
      (word) => data?.first_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.last_name?.toLowerCase().includes(word.toLowerCase()) ||
              data?.status?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  // columns for the leaveMgt
  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Name</p>}
          {row?.first_name + " " + row?.last_name || "--/--"}
        </>
      )
    },
    {
      name: "Description",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Description</p>}
          {useTruncate(row?.description, 100, "...") || "--/--"}
        </>
      )
    },
    {
      name: "Reason",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Reason</p>}
          {useTruncate(row?.reason_for_leave, 100, "...") || "--/--"}
        </>
      )
    },
    {
      name: "Date Created",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Created</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Leave Status",
      center: true,
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon" onClick={(() => {
            handleNavigate(row);
          })}
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
        </div>
      )
    }

  ];

  //   const { type, duration, access } = leaveOptions;

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Student Leave Management"
            subtitle="See the leave status of students in your school"
          />
          <div className="page-content">
            <Table
              data={searchResult}
              columns={columns}
              subHeader={true}
              subHeaderComponent={
                <TableSearch placeholder="Search by name..." searchTableFunc={handleSearchLeaveOptions} />}
              pagination
            />
          </div>
          <Modal
            title="Student Leave Details"
            subtitle="view details of student leave."
            modalContent={
              <>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12}>
                    <div
                      className={classes.memberBox}
                    >
                      <div className={classes.role}>
                        Student Name:
                      </div>
                      <div className={classes.name}>{currentRow?.first_name + " " + currentRow?.last_name || "--/--"}</div>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
              </>
            }
            isopen={leaveOptionModal}
            closeModal={handleLeaveOptionModal}
          />
          <Modal
            title="Student Leave Details"
            subtitle={`View Leave Request of ${currentRow?.first_name + " " + currentRow?.last_name}`}
            modalContent={
              <>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12}>
                    <div
                      className={classes.memberBox}
                    >
                      <div className={classes.role}>
                        Student Name
                      </div>
                      <div className={classes.name}>{currentRow?.first_name + " " + currentRow?.last_name || "--/--"}</div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <div
                      className={classes.memberBox}
                    >
                      <div className={classes.role}>
                        Description
                      </div>
                      <div className={classes.name}>{currentRow?.description || "--/--"}</div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <div
                      className={classes.memberBox}
                    >
                      <div className={classes.role}>
                        Reason
                      </div>
                      <div className={classes.name}>{currentRow?.reason_for_leave || "--/--"}</div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <div
                      className={classes.memberBox}
                    >
                      <div className={classes.role}>
                        Start Date
                      </div>
                      <div className={classes.name}>{currentRow?.start_date?.substring(0, 10) || "--/--"}</div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <div
                      className={classes.memberBox}
                    >
                      <div className={classes.role}>
                        End Date
                      </div>
                      <div className={classes.name}>{currentRow?.end_date?.substring(0, 10) || "--/--"}</div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <div
                      className={classes.memberBox}
                    >
                      <div className={classes.role}>
                        Status
                      </div>
                      <div className={classes.name}><Badge status={currentRow?.status} /></div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <div
                      className={classes.memberBox}
                    >
                      <div className={classes.role}>
                        Created At
                      </div>
                      <div className={classes.name}>{currentRow?.created_at?.substring(0, 10) || "--/--"}</div>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
              </>
            }
            isopen={approveModal}
            closeModal={handleCloseApproveModal}
          />
          <Modal
            title="Need Help?"
            subtitle="Watch the Video Below on Leave Management"
            modalContent={
              <>
                <ReactPlayer
                  url="https://youtu.be/bXQtkoeIreA"
                  playing={true}
                  controls={true}
                  width="100%"
                />
              </>
            }
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleCloseVideoModal}
                  buttonName="Close Video"
                />
              </>}
            isopen={helpModal}
            closeModal={handleCloseVideoModal}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default LeaveMgt;
